import React from "react";
import Navbar from "../../components/navbar/navbar";
import job_interview from '../../assets/images/job_interview.png';
import { Link } from "react-router-dom";
import icon1 from './service_icons/icon1.png'
import icon2 from './service_icons/icon2.png'
import icon3 from './service_icons/icon3.png'
import icon4 from './service_icons/icon4.png'
function LandPurchases(){
    return(
        <>
        <Navbar/>
        <div data-aos="fade-in">
        <div className="services_banner services_banner2">
            <div>
                <h2>Land Purchase Services</h2>
                <p>
                    At Buyers Galaxy, we help you secure the perfect piece of land for your next investment or dream home.
                    Whether you're looking for a development opportunity, a long-term hold, or a prime location for your
                    future residence, our expertise ensures a seamless and strategic buying process.
                </p>
                <Link to="/contact" className="btn">Contact Us</Link>
            </div>
        </div>
        <div className="service_offer">
            <h2 className="offer">What We Offer</h2>
            <div className="offer_blocks">
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon1} alt="" />
                    </div>
                    <div>
                        <h5>Expert Guidance</h5>
                        <p>With our deep knowledge of zoning regulations, development potential, and market trends, we help you identify land
                        that maximizes your investment potential.</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon3} alt="" />
                    </div>
                    <div>
                        <h5>Strategic Insights</h5>
                        <p>We assess each parcel with an investor mindset, ensuring you understand the long-term capital growth and value-adding opportunities</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon4} alt="" />
                    </div>
                    <div>
                        <h5>Industry Connections</h5>
                        <p>Leveraging our network of real estate professionals and developers, we gain access to off-market land deals and prime locations before they hit the open market.</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon2} alt="" />
                    </div>
                    <div>
                        <h5>Tailored Advice</h5>
                        <p>Whether it's for subdivision, development, or personal use, we align your goals with the best land options available.</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
            </div>
        </div>
        <div className="services_info_bottom">
            <p>Discover Melbourne's no-go suburbs for Investment</p>
            <Link to='/download'>Download Now</Link>
        </div>
        <div className="services_info">
            <div className="service_img_detail">
                <h2>Why Choose Us?</h2>
                <p>
                    Let us help you turn a blank canvas into your next wealth-building opportunity. With Buyers Galaxy 
                    by your side, buying land becomes a stress-free and rewarding experience.
                </p>
                {/* <Link to="/contact" className="con-btn">Get a House Now</Link> */}
            </div>
            <img src={job_interview} alt="" />
        </div>
        <div className="services_details"></div>
        </div>
        </>
    );

}
export default LandPurchases;
